"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Input", {
    enumerable: true,
    get: function() {
        return Input;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Input = /*#__PURE__*/ _react.default.forwardRef(function(_param, ref) {
    var className = _param.className, _param_type = _param.type, type = _param_type === void 0 ? "text" : _param_type, prefix = _param.prefix, suffix = _param.suffix, hasError = _param.hasError, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, inputClassName = _param.inputClassName, onBlur = _param.onBlur, darkMode = _param.darkMode, rest = _objectWithoutProperties(_param, [
        "className",
        "type",
        "prefix",
        "suffix",
        "hasError",
        "disabled",
        "inputClassName",
        "onBlur",
        "darkMode"
    ]);
    var _useState = _slicedToArray((0, _react.useState)(false), 2), focused = _useState[0], setFocused = _useState[1];
    var _obj, _obj1;
    var classes = {
        root: (0, _classnames.default)("w-full flex items-center justify-between sm:text-sm rounded-md border overflow-hidden", {
            "ring-1 ring-offset-0": focused
        }, darkMode ? (_obj = {
            "text-white border-gray-600 bg-gray-900 focus:ring-highlight-400 focus:border-highlight-400": true,
            "ring-highlight-400 border-highlight-400": !hasError && !disabled && focused,
            "ring-red-500 border-red-500 text-red-400 placeholder-red-300": !disabled && hasError,
            "border-gray-300 text-gray-500 placeholder-gray-500 bg-gray-50": disabled
        }, _defineProperty(_obj, type === "textarea" ? "h-auto" : "h-9.5", true), _defineProperty(_obj, className || "", className), _obj) : (_obj1 = {
            "text-gray-900 border-gray-300 bg-white": true,
            "ring-accent-500 border-accent-500 focus:ring-accent-500 focus:border-accent-500": !hasError && !disabled && focused,
            "ring-red-500 border-red-500 text-red-900 placeholder-red-300": !disabled && hasError,
            "border-gray-300 text-gray-500 placeholder-gray-500 bg-gray-50": disabled
        }, _defineProperty(_obj1, type === "textarea" ? "h-auto" : "h-9.5", true), _defineProperty(_obj1, className || "", className), _obj1)),
        suffixInput: (0, _classnames.default)("flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-l-md sm:text-sm z-10", darkMode ? {
            "text-white border-gray-600": !disabled,
            "text-gray-500 border-gray-600 placeholder-gray-300 bg-gray-50": disabled,
            "focus:ring-red-500 focus:border-red-500 border-red-500 text-red-400 placeholder-red-300": hasError,
            "focus:ring-highlight-400 focus:border-highlight-400": !hasError
        } : {
            "text-gray-900 border-gray-300": !disabled,
            "text-gray-500 border-gray-300 placeholder-gray-300 bg-gray-50": disabled,
            "focus:ring-red-500 focus:border-red-500 border-red-500 text-red-900 placeholder-red-300": hasError,
            "focus:ring-accent-500 focus:border-accent-500": !hasError
        }),
        input: inputClassName || (0, _classnames.default)("w-full border-none focus:ring-0 focus:ring-offset-0 focus:shadow-none sm:text-sm", {
            "p-2": type === "color"
        }, darkMode ? {
            "text-red-400 placeholder-red-300": hasError,
            "text-gray-500 placeholder-gray-300 bg-gray-50": disabled,
            "text-white bg-gray-900": !disabled
        } : {
            "text-red-900 placeholder-red-300": hasError,
            "text-gray-500 placeholder-gray-300 bg-gray-50": disabled,
            "text-gray-900 bg-white": !disabled
        }),
        prefix: (0, _classnames.default)({
            "flex items-center justify-center h-full": true,
            "bg-gray-900": darkMode && !disabled,
            "bg-white": !darkMode && !disabled,
            "bg-transparent": disabled,
            "pl-4": type !== "color"
        })
    };
    if (type === "textarea") {
        return /*#__PURE__*/ _react.default.createElement("textarea", _extends({}, rest, {
            className: classes.root,
            ref: ref,
            onFocus: function() {
                return setFocused(true);
            },
            onBlur: function(ev) {
                setFocused(false);
                onBlur && onBlur(ev);
            }
        }));
    }
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: suffix ? "flex rounded-md" : classes.root
    }, prefix && /*#__PURE__*/ _react.default.createElement("span", {
        className: classes.prefix
    }, prefix), /*#__PURE__*/ _react.default.createElement("input", _extends({
        className: suffix ? classes.suffixInput : classes.input,
        type: type === "color" ? "text" : type,
        ref: ref,
        disabled: disabled
    }, rest, {
        onFocus: function() {
            return setFocused(true);
        },
        onBlur: function(ev) {
            setFocused(false);
            onBlur && onBlur(ev);
        }
    })), suffix && /*#__PURE__*/ _react.default.createElement("span", {
        className: "inline-flex items-center px-3 rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"
    }, suffix));
});

//# sourceMappingURL=Input.js.map